module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURf///0dwTP///////////////zhyFg0AAAAGdFJOU0wAzBOzQI3zPfoAAACGSURBVCjPnZHJEYAgDEUDNgBjA0wc7+JoBXag/fcikMSF6AVOP48fyAK+OtAE+k6CNRawoKHY4VbAjoGAzSKBGcniEIcCkghkyBdwKebgRRKmOrKWRODnAhu40hSxgYHLwDx7sWL4AyqlflR9WxemSq+bU+2rAdl7hOP3kPtD1jDF1lW+zwmXJSgdvGXWywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/cancelIcon.png
// module id = 1816
// module chunks = 0